import { gql } from '@apollo/client';

export const DASHBOARD_FUNDER_DATA = gql`
  query DashboardFunderData($input: FilterArgs) {
    #totalFunderLearnersInSessions(input: $input)
    totalFunderBeneficiaries(input: $input)
    totalFunderDistrictsInSessions(input: $input)
    totalFunderInterventionTypesInSessions(input: $input)
    totalFunderProvincesInSessions(input: $input)
    totalFunderSchools(input: $input)
    totalFunderSchoolsInSessions(input: $input)
    totalFunderServiceProviders(input: $input)
    totalFunderServiceProvidersInSessions(input: $input)
    totalFunderSessions(input: $input)
    totalFunderStakeholdersInSessions(input: $input)
  }
`;
